var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',[(_vm.show)?_vm._t("default"):_c('div',[_c('b-button',{staticClass:"xl-wide",attrs:{"variant":"outline-primary"},on:{"click":_vm.onAdd}},[_c('b-icon',{attrs:{"icon":"plus-circle-fill"}}),_vm._v(" Add ")],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }